const devicesCommandList = [
  { name: 'Upload Log', value: 'upload-log' },
  { name: 'Send Message', value: 'client-message' },
  { name: 'Kill App', value: 'kill-app' },
  { name: 'Reset Graphic Bundles', value: 'reset-graphic-bundles' },
  { name: 'Delete All Logs', value: 'delete-all-logs' },
  { name: 'Reactivate Device', value: 'reactivate-device' },
]

export default devicesCommandList